// extracted by mini-css-extract-plugin
export default {"description":"ProductInfo_description__akr9Q","collapse":"ProductInfo_collapse__ee-pN"};